













































import Vue from "vue";
import config from "@/configs";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { get, isEmpty } from "lodash";
import { isSuccessfulResponse } from "@/services/util.service";
import { AxiosResponse } from "axios";

export default Vue.extend({
  name: "CustomerCreateCardContent",
  computed: {
    ...mapGetters("auth", ["getAuthEmail"]),
    ...mapGetters("customer", ["getLoading"]),
  },
  data(): any {
    return {
      createMetadata: config?.settings.customerSettings?.createMetadata,
      model: {
        name: null,
        description: null,
      },
    };
  },
  methods: {
    ...mapActions("customer", ["createCustomer"]),
    ...mapMutations("snackbar", ["toastError"]),
    isDescriptionEnabled() {
      return (
        get(
          config,
          "settings.customerSettings.createFields.description.enabled"
        ) === true
      );
    },
    onCreateCustomer() {
      const payload = {
        ...this.model,
      };

      if (!this.isDescriptionEnabled()) {
        delete payload.description;
      }

      // Currently all fields are required for ALL use cases.
      // If a use case comes up where not all the fields are required, this should be abstracted to the config to
      // define which fields are required
      let areAllFieldsFilled = true;
      for (const key in payload) {
        if (areAllFieldsFilled) areAllFieldsFilled = !isEmpty(payload[key]);
      }

      if (areAllFieldsFilled) {
        this.createCustomer(payload).then((res: AxiosResponse) => {
          if (isSuccessfulResponse(res)) {
            this.$emit("created-customer", res.data);
          }
        });
      } else {
        this.toastError({ message: this.$t("errors.allFieldsAreRequired") });
      }
    },
  },
});
